// export const url = "http://localhost:3300";
export const url = "https://www.ns6.microcodepgmt.com";

const ApiConfig = {
  adminLogin: `${url}/auth/admin-login`,
  getProfile: `${url}/auth/getProfile`,
  uploadFile: `${url}/auth/uploadFile`,
  addBlog: `${url}/blog/create`,
  getBlog: `${url}/blog/get`,
  getAdminCategory: `${url}/category/get`,
  addCategory: `${url}/category/create`,
  createCashfreeOrder: `${url}/payment/createCashfreeOrder`,
  addService: `${url}/service/createUpdate`,
  getServices: `${url}/service/getAll`,
  getAllServices: `${url}/service/getAllServices`,
  getDashboardDataApi: `${url}/dashboard/get`,
  getContactFormData: `${url}/contact/getAll`,
  getAllTransectionData: `${url}/payment/getAllTransactions`,
  getServiceBySlug: (slug) => `${url}/service/${slug}`,

  // ✅ SubAdmin APIs
  createSubAdmin: `${url}/subadmin/create`,
  editSubAdmin: (id) => `${url}/subadmin/edit/${id}`,
  deleteSubAdmin: (id) => `${url}/subadmin/delete/${id}`,
  getAllSubAdmins: `${url}/subadmin/all`,
  getSubAdminById: (id) => `${url}/subadmin/${id}`,
  userLogin: `${url}/auth/user-login`,
  registerUser: `${url}/auth/registerUser`,
  sendOtpToEmailUser: `${url}/auth/sendOtpToEmailUser`,
  verifyOtp: `${url}/auth/verifyOtp`,
  resetPassword: `${url}/auth/resetPassword`,
  forgotPassword: `${url}/auth/forgot-password`,
  verifyOtp2: `${url}/auth/verifyOtp2`,
  resetPassword2: `${url}/auth/reset-password`,
  getBlogBySlug: (slug) => `${url}/blog/${slug}`,
  getCategories: `${url}/category/getCategories`,
  searchBlogs: `${url}/blog/searchBlogs`,
  getByType: (type) => `${url}/staticContent/${type}`,

  //Career
  addCareer: `${url}/career/post`,
  allCareer: `${url}/career/getAll`,

  //Job
  addJob: `${url}/job/post`,
  allJob: `${url}/job/getAll`,
  singleJob: `${url}/job/get`,
  updateJob: `${url}/job/update`,
  deleteJob: `${url}/job/delete`,
  searchJob: `${url}/job/search`,

  //Department
  addDepartment: `${url}/department/post`,
  allDepartment: `${url}/department/getAll`,
  singleDepartment: `${url}/department/get`,
  updateDepartment: `${url}/department/update`,
  deleteDepartment: `${url}/department/delete`,
  searchDepartment: `${url}/department/search`,


};

export default ApiConfig;
